import React, { ComponentProps, ReactElement } from 'react';
import { styled } from '@linaria/react';
import { BottomSheet as AtlasBottomSheet } from '@vio/atlas/BottomSheet';
type AtlasBottomSheetProps = ComponentProps<typeof AtlasBottomSheet>;
interface Props extends Omit<AtlasBottomSheetProps, 'titleBarProps'> {
  iconComponent?: ReactElement | null;
}
const HeaderIcon = /*#__PURE__*/styled('div')({
  name: "HeaderIcon",
  class: "h1ycsq48",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => AtlasBottomSheet;
const StyledBottomSheet = /*#__PURE__*/styled(_exp2())({
  name: "StyledBottomSheet",
  class: "s1k944rf",
  propsAsIs: true
});
export const BrandBottomSheet = ({
  iconComponent,
  children,
  ...props
}: Props) => {
  return <StyledBottomSheet {...props} titleBarProps={{
    centerContent: iconComponent ? <HeaderIcon>{iconComponent}</HeaderIcon> : null,
    hasDivider: false
  }}>
      {children}
    </StyledBottomSheet>;
};

require("./index.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");